var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99798 0.00537109C8.99611 0.00537109 8.99423 0.00537109 8.99198 0.00537109C8.75536 0.00537109 8.56373 0.197371 8.56373 0.433621C8.56373 0.669871 8.75536 0.861871 8.99198 0.861871C8.99423 0.861871 8.99611 0.861871 8.99836 0.861871H10.5336L3.55711 7.83837C3.47948 7.916 3.43148 8.02287 3.43148 8.14137C3.43148 8.378 3.62348 8.56962 3.85973 8.56962C3.97786 8.56962 4.08511 8.52162 4.16236 8.44437L11.1389 1.46787V3.00312C11.1389 3.005 11.1389 3.00687 11.1389 3.00912C11.1389 3.24575 11.3305 3.43737 11.5671 3.43737C11.8037 3.43737 11.9954 3.24575 11.9954 3.00912C11.9954 3.00687 11.9954 3.005 11.9954 3.00275V3.00312V0.503371C11.9991 0.482746 12.001 0.458371 12.001 0.433996C12.001 0.197371 11.8094 0.00574609 11.5727 0.00574609C11.5709 0.00574609 11.569 0.00574609 11.5667 0.00574609H8.99761L8.99798 0.00537109ZM0.434109 2.5745C0.197859 2.5745 0.00585938 2.76612 0.00585938 3.00275V11.5666C0.00585938 11.8032 0.197859 11.9949 0.434109 11.9949H8.99798C9.23461 11.9949 9.42623 11.8032 9.42623 11.5666V5.10537C9.42623 5.1035 9.42623 5.10162 9.42623 5.09937C9.42623 4.86275 9.23461 4.67112 8.99798 4.67112C8.76136 4.67112 8.56973 4.86275 8.56973 5.09937C8.56973 5.10162 8.56973 5.1035 8.56973 5.10575V5.10537V11.1384H0.861984V3.43062H6.92086C6.92273 3.43062 6.92461 3.43062 6.92686 3.43062C7.16348 3.43062 7.35511 3.239 7.35511 3.00237C7.35511 2.76575 7.16348 2.57412 6.92686 2.57412C6.92461 2.57412 6.92273 2.57412 6.92048 2.57412L0.434109 2.5745Z",
    fill: "#453DB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external-link-icon.d33829eee12091dbac0d6c713bc5757f.svg";
export { ForwardRef as ReactComponent };